import Vue from 'vue'
import App from './App.vue'
import '@/assets/css/tailwind.css'
import axios from 'axios'

import * as VueGoogleMaps from "vue2-google-maps";

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyDXYZHz-821B34i1rRgRKfySI20niR33_8",
    libraries: "places",
    language: 'ru',
  },
});

Vue.prototype.$axios = axios;


new Vue({
  render: h => h(App),
}).$mount('#app-delivery')
